import * as Lucide from 'lucide-react';

// Mapping of string icon names to lucide-react components.
// Add additional mappings as needed.
const ICON_MAP: Record<string, any> = {
  FileText: Lucide.FileText,
  FileUp: Lucide.FileUp,
  GraduationCap: Lucide.GraduationCap,
  Lightbulb: Lucide.Lightbulb,
  Wrench: Lucide.Wrench,
  Brain: Lucide.Brain,
  Check: Lucide.Check,
  CheckCircle: Lucide.CheckCircle,
  Loader2: Lucide.Loader2,
};

export function getIconByName(name?: string) {
  if (!name) return null;
  return ICON_MAP[name] || (Lucide as any)[name] || null;
}
